import React from 'react';
import { Box, Fab } from '@mui/material';
import WhatsAppIcon from '@mui/icons-material/WhatsApp'; // Ícone do WhatsApp

const FloatingWhatsAppButton = () => {
  return (
    <Box
      sx={{
        position: 'fixed',
        bottom: 16,  // Posição inferior
        right: 16,   // Posição direita
        zIndex: 1000, // Para garantir que o botão fique na frente
      }}
    >
      <Fab
  color="success"
  href="https://wa.me/551143579243" // Adicionando o código do país (55 para Brasil)
  target="_blank"
  rel="noopener noreferrer"
  aria-label="WhatsApp"
  sx={{
    backgroundColor: '#25D366',
    '&:hover': {
      backgroundColor: '#128C7E',
    },
  }}
>
  <WhatsAppIcon sx={{ color: 'white' }} />
</Fab>

    </Box>
  );
};

export default FloatingWhatsAppButton;
